module.exports = __webpack_public_path__ + "img/philosophy.8a22a03d.png";